{
  "REPORT": {
    "HEADER": "การสนทนา",
    "LOADING_CHART": "กำลังโหลดแผนภูมิข้อมูล",
    "NO_ENOUGH_DATA": "ข้อมูลที่เราได้รับไม่เพียงพอต่อการสร้างรายงาน โปรดลองใหม่อีกครั้งในภายหน้า",
    "DOWNLOAD_CONVERSATION_REPORTS": "Download conversation reports",
    "DATA_FETCHING_FAILED": "Failed to fetch data, please try again later.",
    "SUMMARY_FETCHING_FAILED": "Failed to fetch summary, please try again later.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "การสนทนา",
        "DESC": "( ทั้งหมด )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "ข้อความที่ได้รับ",
        "DESC": "( ทั้งหมด )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "ข้อความที่ส่ง",
        "DESC": "( ทั้งหมด )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "ระยะเวลาการตอบกลับครั้งแรก",
        "DESC": "( เฉลี่ย )",
        "INFO_TEXT": "จำนวนการสนทนาทั้งหมดที่ใช้ในการคำนวณ:",
        "TOOLTIP_TEXT": "ระยะเวลาการตอบกลับครั้งแรกเท่ากับ {metricValue} (คำนวณจาก {conversationCount} การสนทนา)"
      },
      "RESOLUTION_TIME": {
        "NAME": "ระยะเวลาในการเสร็จสิ้นการสนทนา",
        "DESC": "( เฉลี่ย )",
        "INFO_TEXT": "จำนวนการสนทนาทั้งหมดที่ใช้ในการคำนวณ:",
        "TOOLTIP_TEXT": "ระยะเวลาในการเสร็จสิ้นการสนทนาเท่ากับ {metricValue} (คำนวณจาก {conversationCount} การสนทนา)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "จำนวนความละเอียด",
        "DESC": "( ทั้งหมด )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "จำนวนความละเอียด",
        "DESC": "( ทั้งหมด )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Handoff Count",
        "DESC": "( ทั้งหมด )"
      },
      "REPLY_TIME": {
        "NAME": "Customer waiting time",
        "TOOLTIP_TEXT": "Waiting time is {metricValue} (based on {conversationCount} replies)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "LAST_7_DAYS": "7 วันที่ผ่านมา",
      "LAST_14_DAYS": "14 วันที่ผ่านมา",
      "LAST_30_DAYS": "30 วันที่ผ่านมา",
      "THIS_MONTH": "This month",
      "LAST_MONTH": "Last month",
      "LAST_3_MONTHS": "3 เดือนที่ผ่านมา",
      "LAST_6_MONTHS": "6 เดือนที่ผ่านมา",
      "LAST_YEAR": "ปีที่ผ่านมา",
      "CUSTOM_DATE_RANGE": "กำหนดช่วงระยะเวลา"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "ใช้งาน",
      "PLACEHOLDER": "เลือกช่วงเวลา"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "จัดกลุ่มโดย",
    "DURATION_FILTER_LABEL": "Duration",
    "GROUPING_OPTIONS": {
      "DAY": "วัน",
      "WEEK": "สัปดาห์",
      "MONTH": "เดือน",
      "YEAR": "ปี"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "วัน"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "วัน"
      },
      {
        "id": 2,
        "groupBy": "สัปดาห์"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "วัน"
      },
      {
        "id": 2,
        "groupBy": "สัปดาห์"
      },
      {
        "id": 3,
        "groupBy": "เดือน"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "วัน"
      },
      {
        "id": 2,
        "groupBy": "สัปดาห์"
      },
      {
        "id": 3,
        "groupBy": "เดือน"
      }
    ],
    "BUSINESS_HOURS": "เวลาทำการ",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "No results found"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "ภาพรวมพนักงาน",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent's name to learn more.",
    "LOADING_CHART": "กำลังโหลดแผนภูมิข้อมูล",
    "NO_ENOUGH_DATA": "ข้อมูลที่เราได้รับไม่เพียงพอต่อการสร้างรายงาน โปรดลองใหม่อีกครั้งในภายหน้า",
    "DOWNLOAD_AGENT_REPORTS": "ดาวน์โหลดรายงานพนักงาน",
    "FILTER_DROPDOWN_LABEL": "เลือกพนักงาน",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "AGENTS": "ค้นหาพนักงาน"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "การสนทนา",
        "DESC": "( ทั้งหมด )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "ข้อความที่ได้รับ",
        "DESC": "( ทั้งหมด )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "ข้อความที่ส่ง",
        "DESC": "( ทั้งหมด )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "ระยะเวลาการตอบกลับครั้งแรก",
        "DESC": "( เฉลี่ย )",
        "INFO_TEXT": "จำนวนการสนทนาทั้งหมดที่ใช้ในการคำนวณ:",
        "TOOLTIP_TEXT": "ระยะเวลาการตอบกลับครั้งแรกเท่ากับ {metricValue} (คำนวณจาก {conversationCount} การสนทนา)"
      },
      "RESOLUTION_TIME": {
        "NAME": "ระยะเวลาในการเสร็จสิ้นการสนทนา",
        "DESC": "( เฉลี่ย )",
        "INFO_TEXT": "จำนวนการสนทนาทั้งหมดที่ใช้ในการคำนวณ:",
        "TOOLTIP_TEXT": "ระยะเวลาในการเสร็จสิ้นการสนทนาเท่ากับ {metricValue} (คำนวณจาก {conversationCount} การสนทนา)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "การสนทนาที่เสร็จสิ้น",
        "DESC": "( ทั้งหมด )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 วันที่ผ่านมา"
      },
      {
        "id": 1,
        "name": "30 วันที่ผ่านมา"
      },
      {
        "id": 2,
        "name": "3 เดือนที่ผ่านมา"
      },
      {
        "id": 3,
        "name": "6 เดือนที่ผ่านมา"
      },
      {
        "id": 4,
        "name": "ปีที่ผ่านมา"
      },
      {
        "id": 5,
        "name": "กำหนดช่วงระยะเวลา"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "ใช้งาน",
      "PLACEHOLDER": "เลือกช่วงเวลา"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "ภาพรวมป้ายกำกับ",
    "DESCRIPTION": "Track label performance with key metrics including conversations, response times, resolution times, and resolved cases. Click a label name for detailed insights.",
    "LOADING_CHART": "กำลังโหลดแผนภูมิข้อมูล",
    "NO_ENOUGH_DATA": "ข้อมูลที่เราได้รับไม่เพียงพอต่อการสร้างรายงาน โปรดลองใหม่อีกครั้งในภายหน้า",
    "DOWNLOAD_LABEL_REPORTS": "ดาวน์โหลดรายงานป้ายกำกับ",
    "FILTER_DROPDOWN_LABEL": "เลือกป้ายกำกับ",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "LABELS": "ค้นหาหัวข้อ"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "การสนทนา",
        "DESC": "( ทั้งหมด )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "ข้อความที่ได้รับ",
        "DESC": "( ทั้งหมด )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "ข้อความที่ส่ง",
        "DESC": "( ทั้งหมด )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "ระยะเวลาการตอบกลับครั้งแรก",
        "DESC": "( เฉลี่ย )",
        "INFO_TEXT": "จำนวนการสนทนาทั้งหมดที่ใช้ในการคำนวณ:",
        "TOOLTIP_TEXT": "ระยะเวลาการตอบกลับครั้งแรกเท่ากับ {metricValue} (คำนวณจาก {conversationCount} การสนทนา)"
      },
      "RESOLUTION_TIME": {
        "NAME": "ระยะเวลาในการเสร็จสิ้นการสนทนา",
        "DESC": "( เฉลี่ย )",
        "INFO_TEXT": "จำนวนการสนทนาทั้งหมดที่ใช้ในการคำนวณ:",
        "TOOLTIP_TEXT": "ระยะเวลาในการเสร็จสิ้นการสนทนาเท่ากับ {metricValue} (คำนวณจาก {conversationCount} การสนทนา)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "จำนวนความละเอียด",
        "DESC": "( ทั้งหมด )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 วันที่ผ่านมา"
      },
      {
        "id": 1,
        "name": "30 วันที่ผ่านมา"
      },
      {
        "id": 2,
        "name": "3 เดือนที่ผ่านมา"
      },
      {
        "id": 3,
        "name": "6 เดือนที่ผ่านมา"
      },
      {
        "id": 4,
        "name": "ปีที่ผ่านมา"
      },
      {
        "id": 5,
        "name": "กำหนดช่วงระยะเวลา"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "ใช้งาน",
      "PLACEHOLDER": "เลือกช่วงเวลา"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "ภาพรวมกล่องข้อความ",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "กำลังโหลดแผนภูมิข้อมูล",
    "NO_ENOUGH_DATA": "ข้อมูลที่เราได้รับไม่เพียงพอต่อการสร้างรายงาน โปรดลองใหม่อีกครั้งในภายหน้า",
    "DOWNLOAD_INBOX_REPORTS": "ดาวน์โหลดรายงานกล่องข้อความ",
    "FILTER_DROPDOWN_LABEL": "เลือกกล่องข้อความ",
    "ALL_INBOXES": "All Inboxes",
    "SEARCH_INBOX": "Search Inbox",
    "FILTERS": {
      "INPUT_PLACEHOLDER": {
        "INBOXES": "Search inboxes"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "การสนทนา",
        "DESC": "( ทั้งหมด )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "ข้อความที่ได้รับ",
        "DESC": "( ทั้งหมด )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "ข้อความที่ส่ง",
        "DESC": "( ทั้งหมด )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "ระยะเวลาการตอบกลับครั้งแรก",
        "DESC": "( เฉลี่ย )",
        "INFO_TEXT": "จำนวนการสนทนาทั้งหมดที่ใช้ในการคำนวณ:",
        "TOOLTIP_TEXT": "ระยะเวลาการตอบกลับครั้งแรกเท่ากับ {metricValue} (คำนวณจาก {conversationCount} การสนทนา)"
      },
      "RESOLUTION_TIME": {
        "NAME": "ระยะเวลาในการเสร็จสิ้นการสนทนา",
        "DESC": "( เฉลี่ย )",
        "INFO_TEXT": "จำนวนการสนทนาทั้งหมดที่ใช้ในการคำนวณ:",
        "TOOLTIP_TEXT": "ระยะเวลาในการเสร็จสิ้นการสนทนาเท่ากับ {metricValue} (คำนวณจาก {conversationCount} การสนทนา)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "จำนวนความละเอียด",
        "DESC": "( ทั้งหมด )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 วันที่ผ่านมา"
      },
      {
        "id": 1,
        "name": "30 วันที่ผ่านมา"
      },
      {
        "id": 2,
        "name": "3 เดือนที่ผ่านมา"
      },
      {
        "id": 3,
        "name": "6 เดือนที่ผ่านมา"
      },
      {
        "id": 4,
        "name": "ปีที่ผ่านมา"
      },
      {
        "id": 5,
        "name": "กำหนดช่วงระยะเวลา"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "ใช้งาน",
      "PLACEHOLDER": "เลือกช่วงเวลา"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "ภาพรวมทีม",
    "DESCRIPTION": "Get a snapshot of your team's performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "กำลังโหลดแผนภูมิข้อมูล",
    "NO_ENOUGH_DATA": "ข้อมูลที่เราได้รับไม่เพียงพอต่อการสร้างรายงาน โปรดลองใหม่อีกครั้งในภายหน้า",
    "DOWNLOAD_TEAM_REPORTS": "ดาวน์โหลดรายงานทีม",
    "FILTER_DROPDOWN_LABEL": "เลือกทีม",
    "FILTERS": {
      "ADD_FILTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "NO_FILTER": "No filters available",
      "INPUT_PLACEHOLDER": {
        "TEAMS": "ค้นหาทีม"
      }
    },
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "การสนทนา",
        "DESC": "( ทั้งหมด )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "ข้อความที่ได้รับ",
        "DESC": "( ทั้งหมด )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "ข้อความที่ส่ง",
        "DESC": "( ทั้งหมด )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "ระยะเวลาการตอบกลับครั้งแรก",
        "DESC": "( เฉลี่ย )",
        "INFO_TEXT": "จำนวนการสนทนาทั้งหมดที่ใช้ในการคำนวณ:",
        "TOOLTIP_TEXT": "ระยะเวลาการตอบกลับครั้งแรกเท่ากับ {metricValue} (คำนวณจาก {conversationCount} การสนทนา)"
      },
      "RESOLUTION_TIME": {
        "NAME": "ระยะเวลาในการจบการสนทนา",
        "DESC": "( เฉลี่ย )",
        "INFO_TEXT": "จำนวนการสนทนาทั้งหมดที่ใช้ในการคำนวณ:",
        "TOOLTIP_TEXT": "ระยะเวลาในการเสร็จสิ้นการสนทนาเท่ากับ {metricValue} (คำนวณจาก {conversationCount} การสนทนา)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "จำนวนความละเอียด",
        "DESC": "( ทั้งหมด )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "7 วันที่ผ่านมา"
      },
      {
        "id": 1,
        "name": "30 วันที่ผ่านมา"
      },
      {
        "id": 2,
        "name": "3 เดือนที่ผ่านมา"
      },
      {
        "id": 3,
        "name": "6 เดือนที่ผ่านมา"
      },
      {
        "id": 4,
        "name": "ปีที่ผ่านมา"
      },
      {
        "id": 5,
        "name": "กำหนดช่วงระยะเวลา"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "ใช้งาน",
      "PLACEHOLDER": "เลือกช่วงเวลา"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "รายงาน CSAT",
    "NO_RECORDS": "No responses yet",
    "NO_RECORDS_DESCRIPTION": "CSAT survey responses will appear here once customers start providing feedback.",
    "DOWNLOAD": "Download CSAT Reports",
    "DOWNLOAD_FAILED": "Failed to download CSAT Reports",
    "FILTERS": {
      "ADD_FILTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "NO_FILTER": "No filters available",
      "INPUT_PLACEHOLDER": {
        "AGENTS": "ค้นหาพนักงาน",
        "INBOXES": "Search inboxes",
        "TEAMS": "ค้นหาทีม",
        "RATINGS": "Search ratings"
      },
      "AGENTS": {
        "LABEL": "พนักงาน"
      },
      "INBOXES": {
        "LABEL": "กล่องข้อความ"
      },
      "TEAMS": {
        "LABEL": "ทีม"
      },
      "RATINGS": {
        "LABEL": "การประเมิน"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "ผู้ติดต่อ",
        "AGENT_NAME": "พนักงาน",
        "RATING": "การประเมิน",
        "FEEDBACK_TEXT": "คำติชม",
        "CONVERSATION": "การสนทนา",
        "CUSTOMER": "Customer",
        "RESPONSE": "Response",
        "HANDLED_BY": "Handled by"
      },
      "UNKNOWN_CUSTOMER": "Unknown customer"
    },
    "NO_AGENT": "No assigned agent",
    "NO_FEEDBACK": "No feedback provided",
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "การตอบกลับทั้งหมด",
        "TOOLTIP": "จำนวนการตอบกลับทั้งหมดที่บันทึกไว้"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "คะแนนความพึงพอใจ",
        "TOOLTIP": "จำนวนการตอบกลับเชิงบวก / จำนวนการตอบกลับทั้งหมด * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "อัตราการตอบกลับ",
        "TOOLTIP": "จำนวนการตอบกลับทั้งหมด / จำนวนข้อความทั้งหมดที่แบบสอบถาม CSAT ส่ง * 100"
      },
      "RATING_DISTRIBUTION": "Rating distribution"
    },
    "REVIEW_NOTES": {
      "TITLE": "Review notes",
      "PLACEHOLDER": "Add review notes about this rating...",
      "SAVE": "Save",
      "CANCEL": "ยกเลิก",
      "SAVING": "กำลังบันทึก...",
      "SAVED": "Notes saved successfully",
      "SAVE_ERROR": "Failed to save notes",
      "UPDATED_BY": "Updated by {name} {time}",
      "UPDATED_BY_LABEL": "Updated by",
      "PAYWALL": {
        "TITLE": "Upgrade to add review notes",
        "AVAILABLE_ON": "The review notes feature is only available in the Business and Enterprise plans.",
        "UPGRADE_PROMPT": "Add internal context to every CSAT response with review notes. Capture what really happened, spot patterns faster, and make better decisions from your feedback.",
        "UPGRADE_NOW": "Upgrade now",
        "CANCEL_ANYTIME": "You can change or cancel your plan anytime"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot Reports",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "No. of Conversations",
        "TOOLTIP": "Total number of conversations handled by the bot"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Total Responses",
        "TOOLTIP": "Total number of responses sent by the bot"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Resolution Rate",
        "TOOLTIP": "Total number of conversations resolved by the bot / Total number of conversations handled by the bot * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Handoff Rate",
        "TOOLTIP": "Total number of conversations handed off to agents / Total number of conversations handled by the bot * 100"
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "ภาพรวม",
    "LIVE": "ขณะนี้",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "การสนทนาที่เปิดอยู่",
      "LOADING_MESSAGE": "กำโหลดตัวชี้วัดการสนทนา",
      "OPEN": "เปิด",
      "UNATTENDED": "ไม่ได้เข้าร่วม",
      "UNASSIGNED": "ไม่ได้รับมอบหมาย",
      "PENDING": "กำลังร้องขอ"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Conversation Traffic",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "RESOLUTION_HEATMAP": {
      "HEADER": "Resolutions",
      "NO_CONVERSATIONS": "No conversations",
      "CONVERSATION": "{count} conversation",
      "CONVERSATIONS": "{count} conversations",
      "DOWNLOAD_REPORT": "Download report"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "การสนทนาที่พนักงานดูแล",
      "LOADING_MESSAGE": "กำลังโหลดตัวชี้วัดพนักงาน",
      "NO_AGENTS": "ไม่มีการสนทนาที่พนักงานดูแล",
      "TABLE_HEADER": {
        "AGENT": "พนักงาน",
        "OPEN": "เปิด",
        "UNATTENDED": "ไม่ได้เข้าร่วม",
        "STATUS": "สถานะ"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "ทีม",
        "OPEN": "เปิด",
        "UNATTENDED": "ไม่ได้เข้าร่วม",
        "STATUS": "สถานะ"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "สถานะพนักงาน",
      "ONLINE": "ออนไลน์",
      "BUSY": "ไม่ว่าง",
      "OFFLINE": "ออฟไลน์"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sunday",
    "MONDAY": "Monday",
    "TUESDAY": "Tuesday",
    "WEDNESDAY": "Wednesday",
    "THURSDAY": "Thursday",
    "FRIDAY": "Friday",
    "SATURDAY": "Saturday"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA Reports",
    "NO_RECORDS": "SLA applied conversations are not available.",
    "LOADING": "Loading SLA data...",
    "DOWNLOAD_SLA_REPORTS": "Download SLA reports",
    "DOWNLOAD_FAILED": "Failed to download SLA Reports",
    "DROPDOWN": {
      "ADD_FIlTER": "Add filter",
      "CLEAR_ALL": "Clear all",
      "CLEAR_FILTER": "Clear filter",
      "EMPTY_LIST": "No results found",
      "NO_FILTER": "No filters available",
      "SEARCH": "Search filter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA name",
        "AGENTS": "Agent name",
        "INBOXES": "Inbox name",
        "LABELS": "ชื่อป้ายกำกับ",
        "TEAMS": "ชื่อทีม"
      },
      "SLA": "SLA Policy",
      "INBOXES": "กล่องข้อความ",
      "AGENTS": "พนักงาน",
      "LABELS": "ป้ายกำกับ",
      "TEAMS": "ทีม"
    },
    "WITH": "with",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Hit Rate",
        "TOOLTIP": "Percentage of SLAs created were completed successfully"
      },
      "NO_OF_MISSES": {
        "LABEL": "Number of Misses",
        "TOOLTIP": "Total SLA misses in a certain period"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Number of Conversations",
        "TOOLTIP": "Total number of conversations with SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Policy",
        "CONVERSATION": "การสนทนา",
        "AGENT": "พนักงาน"
      },
      "VIEW_DETAILS": "View Details"
    }
  },
  "SUMMARY_REPORTS": {
    "INBOX": "กล่องข้อความ",
    "AGENT": "พนักงาน",
    "TEAM": "ทีม",
    "LABEL": "ป้ายกำกับ",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "จำนวนความละเอียด",
    "CONVERSATIONS": "No. of conversations"
  }
}
